import { render } from "./MainSanPham.vue?vue&type=template&id=9061b15c&scoped=true"
import script from "./MainSanPham.vue?vue&type=script&lang=js"
export * from "./MainSanPham.vue?vue&type=script&lang=js"

import "./MainSanPham.vue?vue&type=style&index=0&id=9061b15c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9061b15c"]])

export default __exports__